import React from 'react'
import healthcare1 from '../images/uxgenie1.png';
import healthcare2 from '../images/uxgenie2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function UxGenie() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">UX Genie </span> - Crafting Exceptional User Experiences for the Web
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="UX Genie Web Experience"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">UX Genie</span> – Crafting Exceptional User Experiences for the Web
                        </h1>

                        <p className="mb-3 ps-1">
                            UX Genie is designed to simplify and enhance the process of creating user-centric, responsive, and intuitive web applications.
                            Our platform helps businesses and developers craft exceptional user experiences by leveraging cutting-edge web technologies,
                            design automation, and AI-driven insights.
                        </p>

                        <p className="mb-3 ps-1">
                            With UX Genie, you can effortlessly build custom websites and applications that are not only visually appealing but also highly functional.
                            Features like real-time user interaction analytics, personalized design recommendations, and seamless multi-device support allow
                            you to create truly engaging web experiences.
                        </p>

                        <p className="mb-3 ps-1">
                            The platform supports multilingual content, customizable themes, and dynamic layouts to ensure your website is fully adaptable
                            to different audiences and business needs.
                        </p>

                        <p className="mb-4 ps-1">
                            Whether you are creating a landing page, an e-commerce platform, or a complex web application,
                            UX Genie simplifies the entire design and development process.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> UX Genie – User Experience Transformation Project
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Scope & Technology</h4>
                        <p className="mb-3 ps-3">
                            UX Audit & Design Revamp, Interactive Prototyping, ReactJS, Figma, TailwindCSS, Express.js, MySQL
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Industry</h4>
                        <p className="mb-3 ps-3">Digital Design / Web Applications</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Composition</h4>
                        <p className="mb-3 ps-3">
                            1 UX Strategist, 1 UI Designer, 2 Frontend Engineers, 1 Backend Engineer, 1 Project Coordinator
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Work Duration</h4>
                        <p className="mb-4 ps-3">5 Months</p>

                        <p className="mb-4 ps-3">
                            UX Genie is designed to accelerate and simplify the complex landscape of pharmaceutical patent analysis. It empowers researchers
                            to swiftly identify alternative molecules and formulations and bypass patents of medicines. Users can upload patent documents and
                            research papers in any language, and the app instantly suggests circumvention strategies—cutting research time from months to days.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="UX Genie UI Experience"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="UX Genie Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            Our team built UX Genie with powerful AI and NLP engines, enabling multilingual document analysis, patent scraping,
                            and formulation discovery—all optimized for pharmaceutical research.
                        </p>

                        <p className="mb-3 ps-1">
                            We ensured scientific accuracy, intelligent keyword mapping, and seamless user experience for researchers.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">AI-driven custom web development with automated design suggestions</li>
                            <li className="mb-1">Scalable architecture to support business growth and expansion</li>
                            <li className="mb-1">Real-time performance optimization and smart troubleshooting</li>
                            <li className="mb-1">Seamless integration with existing business systems and third-party tools</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default UxGenie